/**
 * Region Detection Utility
 * Determines the current region based on hostname for multi-region deployment
 * Used by: ProductViewModel, ProductRailViewModel, and other components needing region-aware data
 */

/**
 * Detect current region from hostname
 * @param {string} hostname - The hostname to check (defaults to window.location.hostname)
 * @returns {string} Region code: 'pl', 'eu', or 'en'
 * 
 * Examples:
 *   detectRegion('engryv.pl') → 'pl'
 *   detectRegion('engryv.eu') → 'eu'
 *   detectRegion('engryv.com') → 'en'
 *   detectRegion('localhost') → 'en'
 *   detectRegion() → uses window.location.hostname
 */
export function detectRegion(hostname = window.location.hostname) {
    // Use endsWith() for accurate domain matching
    // endsWith() ensures we match only the TLD, not substring matches
    if (hostname.endsWith('.pl')) {
        return 'pl';
    }
    if (hostname.endsWith('.eu')) {
        return 'eu';
    }
    if (hostname.endsWith('.com')) {
        return 'en';
    }
    // Default for localhost or unknown domains
    return 'en';
}
